<template>
    <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
            <v-chip
                small
                color="primary"
                text-color="white"
                v-bind="attrs"
                v-on="on"
            >
                <v-icon left small>mdi-star</v-icon>
                Premium
            </v-chip>
        </template>
        <span>Disponível apenas no plano Premium</span>
    </v-tooltip>
</template>

<script>
export default {
    name: 'ProBadge'
};
</script>
